<script lang="ts">
  import { SlugLayout } from '../../(components)';
  import MetaTitle from '$lib/components/meta/meta-title.svelte';

  export let data;
</script>

<MetaTitle title={data.article?.attributes?.meta?.title ?? 'Premium Tutorial'} />
<SlugLayout {data} />
